import { NgModule } from '@angular/core';
import { AutomaticDebitComponent } from './rem/automatic-debit.component';
import { AutomaticDebitTableComponent } from './rem/automatic-debit-table/automatic-debit-table.component';
import { AutomaticDebitFilesComponent } from './rem/automatic-debit-files/automatic-debit-files.component';
import { AutomaticDebitImportComponent } from './ret/automatic-debit-import/automatic-debit-import.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutomaticDebitSelecFileComponent } from './ret/automatic-debit-selec-file/automatic-debit-selec-file.component';
import { AutomaticDebitRetTableComponent } from './ret/automatic-debit-ret-table/automatic-debit-ret-table.component';
import { AutomaticDebitBreadcrumbComponent } from './components/automatic-debit-breadcrumb/automatic-debit-breadcrumb.component';
import { AutomaticDebitSelectDialogComponent } from './rem/automatic-debit-select-dialog/automatic-debit-select-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileReturnModule } from '../fileReturn/fileReturn.module';

@NgModule({
    declarations: [
        AutomaticDebitComponent,
        AutomaticDebitTableComponent,
        AutomaticDebitFilesComponent,
        AutomaticDebitImportComponent,
        AutomaticDebitSelecFileComponent,
        AutomaticDebitRetTableComponent,
        AutomaticDebitBreadcrumbComponent,
        AutomaticDebitSelectDialogComponent,
    ],
    exports: [],
    imports: [ComponentsModule, CommonModule, FormsModule, NgbModule, DragDropModule, FileReturnModule],
    providers: [NgbActiveModal],
})
export class AutomaticDebitModule {}
